import { postRequest } from '../utils/provider';
import { ApiResponse } from '../utils/responseTransform';

export interface SsoConfig {
  uuid: string;
  provider: string;
}

export interface SsoDiscoverResponse {
  ssoEnabled: boolean;
  ssoRequired: boolean;
  configs: SsoConfig[];
}

export interface SsoLoginResponse {
  loginUrl: string;
}

export async function discoverSso(email: string): Promise<ApiResponse<SsoDiscoverResponse>> {
  return postRequest<SsoDiscoverResponse, never>('sso/discover', { email });
}

export async function initiateSsoLogin(uuid: string, email: string): Promise<ApiResponse<SsoLoginResponse>> {
  return postRequest<SsoLoginResponse, never>('sso/login', { uuid, email });
}
